import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function DashboardController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.DASHBOARD;

  const getDashboardDailyState = <T>(data: { shopName: string, timezone: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/stats`, options);
  };

  return {
    getDashboardDailyState,
  };
}
